module.exports = Em.Handlebars.compile("<div class=\"file-list\">\n    {{each attachments itemViewClass=\"view.fileViewClass\"}}\n</div>");